import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AddMasterTempCategoryComponent } from 'src/app/middleware/common/addMasterTempCategory/addMasterTempCategory.component';
import { MasterTemplateCategory } from '../services/settingService/setting.enum';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ProcessStagesType } from '../../../middleware/common/Enum/common.enum';
@Component({
  selector: 'app-manage-snfsetprocess',
  templateUrl: './manage-snfsetprocess.component.html',
  styleUrls: ['./manage-snfsetprocess.component.scss']
})
export class ManageSNFSetProcessComponent implements OnInit { 
  
  formDialog: FormGroup;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;  
  categoryIdForDialog: number = 0;
  value = '';
  filterText: any;   
  totalCount: any;
  paginatorTotalLength: any;
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;  
  OfficeIDList: any=[];
  myOfficeID: any;
  spinner:boolean=false;
  selectedCategoryID:number=0;
  ShowNoRecordFound:boolean=false;
  categoryList: any[] = [];
  MedicalStageList :any[] = [];
  ProcessStageList  :any[] = [];
  masterTemplateList: any[] = [];
  categoryName:string="";
  processStageID:number=0;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService, private toastr: ToastrService,
     private statusConst: StatusConstant, private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('processStageName',this.formBuilder.control(''));    
    this.getDashboardProcessStagesforManage();
  }

   // For Get All List
   getDashboardProcessStagesforManage(){
    var ReqModel={     
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: this.databaseId     
    }
     this.loaderService.show();
     this.settingsService.getDashboardProcessStagesforManage(ReqModel).subscribe(response => {
     if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
           if(this.responseHolder.data!=null){
              this.categoryList=this.responseHolder.data;   
               this.ProcessStageList = this.responseHolder.data.filter(item => 
               item.categoryID ===  ProcessStagesType.Dashboard
             );  
              
             this.MedicalStageList = this.responseHolder.data.filter(item => 
                item.categoryID ===  ProcessStagesType.PDPM
             );          
              if(this.categoryList.length>0){              
                this.ShowNoRecordFound=false;
             }else{
                this.ShowNoRecordFound=true;
              } 
             }
         }else{
          this.loaderService.hide();
         }
       }else{
        this.loaderService.hide();
       }
     });
   }
   
    title:string="";
    //For  Open Pop (Add)
     openDialogAdd(templateRef: TemplateRef<any> ,categoryId: number) {
      if(categoryId==1){
        this.title="Process";
      }
      if(categoryId==2){
        this.title="PDPM";
      }
      this.categoryIdForDialog = categoryId;
      this.formDialog.markAsPristine();
      this.formDialog.controls.processStageName.setValue("");
      this.processStageID=0;
      this.dialog.open(templateRef, {
      });
     }

   //For  Open Pop (Update)
   openDialogUpdateType(templateRef: TemplateRef<any>, type: any) {
    this.formDialog.markAsPristine();
    this.formDialog.controls.processStageName.setValue(type.processStageName);
    this.processStageID=type.processStageID;
    this.dialog.open(templateRef, {
    });
   }
 
    // For Add Category name
    AddCategoryNameDetails(data ,CategoryId) {
      this.spinner=true;
      this.formDialog.markAsPristine();   
      var ReqModel = {
          categoryId :CategoryId,
          processStageID: this.processStageID,
          processStatusName: data.processStageName.trim(),
          userId: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeID:this.myOfficeID
      }
      this.settingsService.addProcessStage(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.spinner=false;      
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess){
            this.dialog.closeAll();
            this.getDashboardProcessStagesforManage();
            this.toastr.success('Stage added successfully.', '', {
              timeOut: 3000,
            });
          }else{
            this.toastr.warning('Stage already exist.', '', {
              timeOut: 2000,
            });
            this.spinner=false;         
          }
        }else{
          this.spinner=false;       
        }
      });
     }

   // For Update Category name
   UpdateCategoryNameDetails(data) {
    this.spinner=true;
    this.formDialog.markAsPristine();   
    var ReqModel = {
        processStageID: this.processStageID,
        processStateName: data.processStageName.trim(),       
        userId: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeIDList:this.OfficeIDList,
        officeID:this.myOfficeID,
        databaseID: Number(this.databaseId),
    }
    this.settingsService.renameDashboardProcessStages(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;      
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess){         
          this.toastr.success('Stage updated successfully.', '', {
            timeOut: 3000,
          });          
          this.getDashboardProcessStagesforManage();
          this.dialog.closeAll();
        }else{
          this.toastr.warning('Stage already exist.', '', {
            timeOut: 2000,
          });
          this.spinner=false;         
        }
      }else{
        this.spinner=false;       
      }
    });
   }

   // For Update Category Status
   UpdateStatus(event: MatSlideToggleChange,type: any) {
    this.loaderService.show();
    var ReqModel = {
      processStageID: type.processStageID,
      isActive:event.checked,
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.changeActiveStatusforProcessStages(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getDashboardProcessStagesforManage();
          this.loaderService.hide();
          this.toastr.success('Stage status updated successfully.', '', {
            timeOut: 3000,
          });          
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
   }


   // For Update Category Status
   UpdateShowOnDashboard(event: MatCheckboxChange,type: any) {
    this.loaderService.show();
    var ReqModel = {
      processStageID: type.processStageID,
      showOnDashboard:event.checked,
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID:this.myOfficeID,
    }
    this.settingsService.updateShowOnDashboard(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getDashboardProcessStagesforManage();
          this.loaderService.hide();
          this.toastr.success('Stage status updated successfully.', '', {
            timeOut: 3000,
          });          
          
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
   }

   SetDefaultProcessStage(event: MatCheckboxChange,type: any) {
    this.loaderService.show();    
    if(event.checked){      
        var ReqModel = {
        processStageID: type.processStageID,
        userId: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID:this.myOfficeID,
        categoryid : type.categoryID
         }
        this.settingsService.setDefaultProcessStage(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              
              this.getDashboardProcessStagesforManage();
              this.loaderService.hide();
              this.toastr.success('Stage set default successfully.', '', {
                timeOut: 3000,
              });          
              
            }else{
              this.loaderService.hide();
            }
          }else{
            this.loaderService.hide();
          }
        });
    }
    else{
      this.toastr.success('Choose another one to set default this will automatically unset as Default', '', {
        timeOut: 3000,
      });          
    }
   }
   // For Delete Category
   DeleteCategory(type: any) {  
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var ReqModel = {
          processStageID: type.processStageID,            
          userId: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeIDList:this.OfficeIDList,
          officeID:this.myOfficeID,
          databaseID: Number(this.databaseId),
        }            
        this.settingsService.removeDashboardProcessStages(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.getDashboardProcessStagesforManage();
              this.loaderService.hide();
              this.toastr.success('Stage deleted successfully.', '', {
                timeOut: 3000,
              });
             
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
   }
   
drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.categoryList, event.previousIndex, event.currentIndex);
    var record:any=[]=[];
    var reOrdersList:any=[]=[];
    record = this.categoryList;
    if(record.length>0){     
      reOrdersList=[];
      for (let i = 0; i < record.length; i++) {     
        var obj={
          processStageID: record[i].processStageID,          
          position: i+1
        }
        reOrdersList.push(obj);
      }     

      var reqModel={
        stages:reOrdersList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID
      }
      this.loaderService.show();
      this.settingsService.reorderProcessStages(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {          
            this.getDashboardProcessStagesforManage();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }
   close() {
    this.dialog.closeAll();
   }


   Search(filterValue) {
    this.filterText = filterValue.trimLeft();
    this.pageModelData.searchValue = filterValue.trim();  
   }

   clearFilter(){
    this.value = "";
    this.filterText = "";
    this.pageModelData.searchValue = this.filterText.trim();  
    }
     

}
